import { CreateUpdateDebtAccountMovement, DebtAccountMovement } from "./types";

export const convertDebtAccountMovementToCreateUpdateObject = (
  movement: DebtAccountMovement,
): CreateUpdateDebtAccountMovement => {
  const { id, createdAt, updatedAt, manual, ...data } = movement;

  return data;
};
